
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Build payroll with Gusto, then use Plaid Auth to instantly connect your customers' bank accounts and run payroll faster"
};
export const partnerProps = {
  partner: 'Gusto',
  clientLibrary: 'gusto',
  subtitle: metadata.description,
  registrationUrl: 'https://dev.gusto.com/accounts/sign_up',
  apiUrl: 'https://docs.gusto.com',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Gusto and Plaid have partnered so your customers can quickly and easily configure company bank accounts for seamless, in-app payroll.`}</p>
    <p>{`You shouldn't compromise on payroll accuracy and compliance for your customers and their employees. With Gusto Embedded Payroll's APIs, you can leverage the road-tested payroll engine and expertise of Gusto to build payroll capabilities directly into your platform.`}</p>
    <p>{`This integration allows your customers to easily connect company bank accounts through Plaid's Auth flow. A `}<inlineCode parentName="p">{`processor_token`}</inlineCode>{` is a Plaid token used by Gusto to make API calls on your behalf. You will generate a `}<inlineCode parentName="p">{`processor_token`}</inlineCode>{` on behalf of the customer and then pass that token to Gusto. The token allows Gusto to instantly retrieve bank account details, so you don't need to store and protect sensitive bank information.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
